/*********************************************************************************************
* Initialize the Splide carousel for the cart section.
	*
*/
function mmInitSplideRea() {
    const id = '.splide-rea';
    const splideElem = document.querySelector(id);

    if (splideElem) {
        new Splide(splideElem, {
            type: 'loop',
			autoplay: true,
            interval: 3000,
            arrows: false,
            pagination: true,
            perPage: 1
        }).mount();
    }
}

function mmInitSplideCross() {
    const id = '.splide-cross';
    const splideElem = document.querySelector(id);

    if (splideElem) {
        new Splide(splideElem, {
            type: 'splide',
            arrows: false,
            pagination: false,
            rewind: true,
            gap: 12,
            perPage: 2,
            padding: {
              left: '16px',
              right: '80px'
            },
            breakpoints: {
              768: {
                perPage: 1
              }
            }
        }).mount();
    }
}

/*********************************************************************************************
* Creates a debounced function that delays invoking func until after duration milliseconds have elapsed since the last time the debounced function was invoked.
	*
	* @param {Function} func - The function to debounce.
	* @param {number} duration - The number of milliseconds to delay.
	* @returns {Function} - The debounced function.
*/
function debounce(func, duration) {
    let timeout;
    return function (...args) {
        const effect = () => {
            timeout = null;
            return func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(effect, duration);
    };
}

/*********************************************************************************************
* Get the full cart section ID from the DOM.
	*
	* @returns {HTMLElement} - The full cart section ID with the prefix.
*/
function mmCartSectionIdLong() {
	return document.querySelector('.mm-cart').id;
}

/*********************************************************************************************
* Get the cart section ID from the DOM, removing the "shopify-section-" prefix.
	*
	* @returns {HTMLElement} - The cart section ID without the "shopify-section-" prefix.
*/
function mmCartSectionId() {
	return document.querySelector('.mm-cart').id.replace('shopify-section-', '');
}

/*********************************************************************************************
* Get the cart section element from the DOM.
	*
	* @returns {HTMLElement} - The cart section element.
*/
function mmCartSectionElement() {
    return document.getElementById(`${mmCartSectionIdLong()}`);
}

/*********************************************************************************************
* Get the cart product container element from the cart section.
	*
	* @returns {HTMLElement} - The cart product container element.
*/
function mmCartProductsContainerElement() {
    return mmCartSectionElement().querySelector('.mm-dc-products-container');
}

/*********************************************************************************************
* Get the cart item element for a specific product variant.
	*
	* @param {number} line_index - The line item index.
	* @returns {HTMLElement} - The cart item element.
*/
function mmCartItem(line_index) {
    return mmCartProductsContainerElement().querySelector(`[data-line-index="${line_index}"]`);
}
function mmCartItemId(id) {
    return mmCartProductsContainerElement().querySelector(`[data-cart-item-id="${id}"]`);
}

/*********************************************************************************************
* Get the cart item quantity element for a specific product variant.
	*
	* @param {number} line_index - The line item index.
	* @returns {HTMLElement} - The cart item quantity element.
*/
function mmCartItemQuantityEl(line_index) {
    const itemEl = mmCartItem(line_index);
    return itemEl.querySelector('[data-item-quantity]');
}

/*********************************************************************************************
* Get the quantity of a specific cart item.
	*
	* @param {number} line_index - The line item index.
	* @returns {number} - The quantity of the cart item.
*/
function mmGetCartItemQuantity(line_index) {
    const quantityEl = mmCartItemQuantityEl(line_index);
    return Number.parseInt(quantityEl.dataset.itemQuantity);
}

/*********************************************************************************************
* Set the quantity of a specific cart item and update the DOM.
	*
	* @param {number} line_index - The line item index.
	* @param {number} newQuantity - The new quantity to set.
*/
function mmSetCartItemQuantity(line_index, newQuantity) {
    if (newQuantity >= 0) {
        const itemEl = mmCartItem(line_index);

        // MAJ si select présent
        const selectEl = itemEl.querySelector('.mm-dc-product-qqty-select');
        if (selectEl) {
            selectEl.value = newQuantity;
            selectEl.dataset.itemQuantity = newQuantity;
        }
    }
}

/*********************************************************************************************
* Create a new cart element from the provided data.
	*
	* @param {Object} data - The data containing cart HTML.
	* @returns {HTMLElement} - The new cart element.
*/
function mmCartHTMLFromData(data) {
    const el = document.createElement('DIV');
    el.innerHTML = data.sections[mmCartSectionId()];
    return el;
}

/*********************************************************************************************
* Extract the items container from the new cart HTML.
	*
	* @param {Object} data - The data containing cart HTML.
	* @returns {HTMLElement} - The items container element.
*/
function extractItemsFromCartHTML(data) {
    const el = mmCartHTMLFromData(data);
    return el.querySelector('.mm-dc-products-container');
}

/*********************************************************************************************
* Insert cart products from the response data into the current cart in the DOM.
	*
	* @param {Object} data - The data containing the new cart HTML.
	* @returns {Object} - The response data.
*/
function insertCartProductsFromResponse(data) {
    const itemsContainer = extractItemsFromCartHTML(data);
    mmCartProductsContainerElement().innerHTML = itemsContainer.innerHTML;
    return data;
}

/*********************************************************************************************
* Extract the total price element from the new cart HTML.
	*
	* @param {Object} data - The data containing the new cart HTML.
	* @returns {HTMLElement} - The total price element.
*/
function extractTotalPriceFromCartHTML(data) {
    const cartEl = mmCartHTMLFromData(data);
    return cartEl.querySelector('[data-cart-total-price]');
}

/*********************************************************************************************
* Insert the total price from the response data into the current cart in the DOM.
	*
	* @param {Object} data - The data containing the new cart HTML.
	* @returns {Object} - The response data.
*/
function insertInsertTotalPriceFromResponse(data) {
    const newTotalPriceEl = extractTotalPriceFromCartHTML(data);
    const currentTotalPriceEl = mmCartSectionElement().querySelector('[data-cart-total-price]');
    currentTotalPriceEl.innerHTML = newTotalPriceEl.innerHTML;
    return data;
}

/*********************************************************************************************
* Perform an API request to fetch or update cart data.
	*
	* @param {string} method - The HTTP method (GET, POST, etc.).
	* @param {string} path - The API endpoint path.
	* @param {Object} body - The request body data.
	* @returns {Promise<Object>} - A promise resolving to the response data.
*/
function mmAPIRequest(method, path, body) {
    document.querySelector('.mm-dc-products')?.classList?.add('mm-inactive');
    return fetch(window.Shopify.routes.root + path, {
        method: method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    })
        .then((response) => response.json())
        .then((data) => {
            // mmLog(data);
            document.querySelector('.mm-dc-products')?.classList?.remove('mm-inactive');
            updateCartCount();
            if (data.status && data.status > 400) {
                throw data;
            } else {
                return data;
            }
        });
}

/*********************************************************************************************
* Fetch the current cart data.
	*
	* @returns {Promise<Object>} - A promise resolving to the cart data.
*/
function mmGetCart() {
    return mmAPIRequest('GET', 'cart.js');
}

/*********************************************************************************************
	* Open the cart drawer and fetch the latest cart data.
*/
function mmOpenCart() {
    mmGetCart();
	const cartFilter = document.querySelector('.mm-drawer-cart-wrapper');
    const html = document.querySelector('html');

    if (!cartFilter || !html) return;

    cartFilter.classList.add('mm-dc-is-open');
    html.classList.add('stop-scrolling');
}

/*********************************************************************************************
* Close the cart drawer and allow page scrolling.
	*
*/
function mmCloseCart() {
    document.querySelector('.mm-drawer-cart-wrapper').classList.remove('mm-dc-is-open');
    document.querySelector('html').classList.remove('stop-scrolling');
}

/*********************************************************************************************
* Re-render the cart inner HTML from the response data and initialize Splide carousels.
	*
	* @param {Object} data - The data containing the new cart HTML.
	* @returns {Object} - The response data.
*/
function refreshCartFromData(data) {
    const newCartEl = document.createElement('DIV');
    newCartEl.innerHTML = data.sections[mmCartSectionId()];
    const innerCart = mmCartSectionElement().querySelector('.mm-drawer-cart');
    innerCart.innerHTML = newCartEl.querySelector('.mm-drawer-cart').innerHTML;
    mmInitSplideRea();
    mmInitSplideCross();
    mmSetupProductForm();
    updateCartCount();
    return data;
}


/*
			.then(async (response) => {
				const data = await response.json();

				if (!response.ok) {
					// Erreur type 422, afficher le message
					alert(data.message || "Erreur lors de l’ajout au panier.");
					throw new Error(data.message);
				}
				mmGetCart();
				refreshProductCards(data);
				showAddToCartPopup(data);
				mmAddOrRemoveFreeProducts(data);
				mmOpenAndRefreshCart();
			})
			.catch((error) => {
				console.error("Erreur:", error);
			});
*/
/*********************************************************************************************
	* Sets up the cart form submission handler.
*/
function mmSetupProductForm() {
	const forms = document.querySelectorAll("[data-type='add-to-cart-form']");
	if (!forms) return;

	forms.forEach(form => {
		form.addEventListener("submit", function (event) {
			event.preventDefault();

			const formData = new FormData(form);
            formData.append('sections', mmCartSectionId());

			fetch("/cart/add.js", {
				method: "POST",
				body: formData,
			})
			.then(response => response.json())
            .then((data) => {
              console.log("Produit ajouté:", data);
              return mmAddOrRemoveFreeProducts(data);
            })
            .then(refreshCartFromData)
            .then(mmOpenCart)
			.catch(error => {
				console.error("Erreur:", error);
			});
		});
	});
}

/*********************************************************************************************
* Refresh the cart and open the cart drawer
*/
function mmOpenAndRefreshCart() {
    function handleResponse() {
        const newCartEl = document.createElement("DIV");
        newCartEl.innerHTML = this.responseText;
        const innerCart = mmCartSectionElement().querySelector(".mm-drawer-cart");
        innerCart.innerHTML = newCartEl.querySelector(".mm-drawer-cart").innerHTML;

        mmInitSplideRea();
        mmInitSplideCross();
        mmSetupProductForm();
        updateCartCount();
        mmOpenCart();
    }
    const request = new XMLHttpRequest();
    request.addEventListener("load", handleResponse);
    request.open("GET", `/?section_id=${mmCartSectionId()}`, true);
    request.send();
}

/*********************************************************************************************
* Remove a specific product from the cart.
	*
	* @param {number} line_index - The line item index.
*/
function mmDestroyProductFromCart(line_index) {
    const newQuantity = 0;
    mmSetCartItemQuantity(line_index, newQuantity);
    mmDebouncedPushNewQuantity(line_index);
}

/*********************************************************************************************
* Push the new quantity of a specific product to the server.
	*
	* @param {number} line_index - The line item index.
*/
function mmChangeProductQuantity(selectEl) {
    const lineIndex = parseInt(selectEl.dataset.lineIndex, 10);
    const newQuantity = parseInt(selectEl.value, 10);
    const maxQtty = parseInt(selectEl.dataset.max, 10);

    if (newQuantity > maxQtty) return;

    mmSetCartItemQuantity(lineIndex, newQuantity);
    mmDebouncedPushNewQuantity(lineIndex);
}

/*********************************************************************************************
* Push the new quantity of a specific product to the server.
	*
	* @param {number} line_index - The line item index.
*/
function mmPushNewQuantity(line_index) {
    const quantity = mmGetCartItemQuantity(line_index);
    mmAPIRequest('POST', 'cart/change.js', {
        line: line_index,
        quantity: quantity,
        sections: mmCartSectionId(),
    })
	.then(mmAddOrRemoveFreeProducts)
	.then(refreshCartFromData)
	.then((data) => {
	})
	.catch((error) => {
		alert(error.message)
		console.log(error);
		//location.reload();
	})
}

/*********************************************************************************************
* Remove a line item from the cart.
	*
	* @param {number|string} line_index - The index of the line item in the cart to be removed.
*/
function mmDestroyLineItemFromCart(line_index) {
    mmAPIRequest("POST", "cart/change.js", {
        line: parseInt(line_index),
        quantity: 0,
        sections: mmCartSectionId(),
    })
    .then(refreshCartFromData);
}

/*********************************************************************************************
* Debounced function to push new quantity of a specific product to the server.
	*
	* @param {number} line_index - The line item index.
 */
const mmDebouncedPushNewQuantity = debounce(function (line_index, maxQtty) {
	const quantity = mmGetCartItemQuantity(line_index);

    if (quantity > maxQtty) {
        return;
    }
	mmPushNewQuantity(line_index);
}, 300);

/*********************************************************************************************
* Update the cart count bubble with the given value.
	*
	* @param {number} value - The new cart count value.
*/
function updateCartCount() {
  const productCount = parseInt(document.querySelector('.mm-dc-header').dataset.cartCount);
  const countBubbles = document.querySelectorAll(".mm-cart-count-bubble");

  countBubbles.forEach(function(countBubble) {
    countBubble.innerText = productCount;
  })

  console.log('productCount', productCount)

  if (productCount > 0) {
    countBubbles.forEach(function(countBubble) {
      countBubble.classList.remove('mm-none');
    })
  } else {
    countBubbles.forEach(function(countBubble) {
      countBubble.classList.add('mm-none');
    })
    localStorage.setItem("no_free_product_please", "");
  }
}

/*********************************************************************************************
* Add or remove free products from the cart based on conditions.
	*
	* @param {Object} data - The data containing the new cart HTML.
	* @returns {Object} - The response data.
*/
function mmAddOrRemoveFreeProducts(data) {
    if (!data || !data.sections) {
		console.warn("Données invalides dans mmAddOrRemoveFreeProducts, passage des données sans traitement", data);
		return data;
	}
  
    if (data.sections[mmCartSectionId()]) {
        const el = mmCartHTMLFromData(data);
        const freeProductEls = el.querySelector('[data-free-products]');
        let freeProductCounts = 0;

        if (!freeProductEls) {
          return data;
        }

        // creates an object like { 44058675: 1, 44058001: 0 }
        // where key is free product id and value, its quantity
        const productsParams = Array.from(freeProductEls.children).reduce((param, freeProductEl) => {
            const variantId = freeProductEl.dataset.variantId;
            const productId = freeProductEl.dataset.productId;
            const isFree = freeProductEl.dataset.freeProduct == 'true';
            const itemEl = document.querySelector(`.mm-dc-products .mm-dc-product[data-cart-item-product-id="${ productId }"`);
            if (isFree) {
                freeProductCounts += 1;
            }
            if (itemEl && isFree) {
                console.log('do nothing, item is already added');
                // do nothing, item is already added
            } else if (itemEl && !isFree) {
                // item is present but should be removed
                const variantIdToRemove = parseInt(itemEl.dataset.cartItemId);
                console.log('item is present but should be removed', variantIdToRemove);
                param[variantIdToRemove] = 0;
            } else if (!itemEl && isFree) {
                console.log('item is absent but should be added', productId);
                // item is absent but should be added
                 if (localStorage.getItem("no_free_product_please") == 'true') {
                 } else {
                   param[variantId] = 1;
                 }
            } else {
              console.log('else')
            }
            return param;
        }, {});

        // Add or remove free products only if needed
        if (Object.keys(productsParams).length > 0) {
            mmAPIRequest('POST', 'cart/update.js', { updates: productsParams, sections: mmCartSectionId() }).then(refreshCartFromData)
           .then(updateCartCount);
        }
    }
    return data;
}

/*********************************************************************************************
* Add a free product to the cart and optionally open the cart drawer.
	*
	* @param {number} productId - The free product ID to add.
	* @param {Object} options - Options for adding the product.
	* @param {number} [options.quantity=1] - The quantity to add.
	* @param {boolean} [options.openCart=true] - Whether to open the cart drawer after adding the product.
	* @param {HTMLElement} clickedElem - The element that was clicked to trigger this action.
*/
function mmAddFreeProductToCart(productId, { quantity = 1, openCart = true }, clickedElem) {
    // Debounce on the CTA
    clickedElem.innerText = 'AJOUTÉ !';
    clickedElem.classList.add('mm-disabled');

    // Ajouter le free product
    mmAddProductToCart(productId, { openCart: false });
}

function mmDestroyProductFromCartForEver(line_index) {
    localStorage.setItem("no_free_product_please", "true");
    const newQuantity = 0;
    mmSetCartItemQuantity(line_index, newQuantity);

    mmDebouncedPushNewQuantity(line_index);
}

/*********************************************************************************************
* Add a product to cart and optionally open the cart drawer.
*
* @param {number} variantId - The variant ID to add.
* @param {Object} options - Options for adding the product.
* @param {number} [options.quantity=1] - The quantity to add.
* @param {boolean} [options.openCart=true] - Whether to open the cart drawer after adding.
*/
function mmAddProductToCart(variantId, { quantity = 1, openCart = true } = {}) {
    mmAPIRequest("POST", "cart/add.js", {
        items: [{
            id: variantId,
            quantity: quantity
        }],
        sections: mmCartSectionId(),
    })
    .then(refreshCartFromData)
    .then((data) => {
        if (openCart) {
            setTimeout(mmOpenCart, 100);
        }
    })
    .catch((error) => {
        alert(error.message);
        console.error(error);
    });
}

/*********************************************************************************************
* Add a product with upsell to the cart and optionally open the cart drawer.
*
* @param {number} parentVariantId - The parent variant ID.
* @param {number} upsellVariantId - The upsell variant ID.
* @param {Object} options - Options for adding the product.
* @param {number} [options.parent_quantity=1] - The quantity of the parent product.
* @param {boolean} [options.openCart=true] - Whether to open the cart drawer after adding.
*/
function mmAddProductWithUpsellToCart(parentVariantId, upsellVariantId, { parent_quantity = 1, openCart = true }) {
  mmAPIRequest("POST", "cart/add.js", {
      items: [
        {
          id: parentVariantId,
          quantity: parent_quantity
        },
        {
          id: upsellVariantId,
          quantity: 1,
          properties: {
            '_parent_product': parentVariantId
          }
        }
      ],
  sections: mmCartSectionId(),
  })
  .then(refreshCartFromData)
  .then((data) => {
      if (openCart) {
          setTimeout(mmOpenCart);
      }
  })
  .catch((error) => {
      alert(error.message)
      mmOpenCart();
      console.log(error);
      location.reload();
  });
}

function mmAddProductToCartFromProductFrom() {
// 1: on regarde si la checkbox de cross-sell existe, si oui on regarde si elle est checked

const upsellMetafieldElement = document.getElementById('upsell-metafield');

// Si l'élément existe, vérifier le dataset
if (upsellMetafieldElement && upsellMetafieldElement.dataset.upsell) {
// Récupérer la valeur du metafield upsell
const upsellMetafield = upsellMetafieldElement.dataset.upsell;
  console.log("Le metafield product_upsell n'est pas vide:", upsellMetafield);

  // Logique d'ajout au panier
  const checkbox = document.querySelector('.mm-container-product-form .mm-check-upsell');
  const variant_id = document.getElementById('product_id').value;
  const variant_quantity = document.getElementById('mm-quantity-main-product').value;

  if (checkbox) {
    if (checkbox.checked) {
      const upsell_variant_id = checkbox.dataset.variantId;
      mmAddProductWithUpsellToCart(variant_id, upsell_variant_id, { parent_quantity: variant_quantity, openCart: true });
    } else {
  const checkbox = document.querySelector('.mm-container-product-form .mm-check-upsell');
  const variant_id = document.getElementById('product_id').value;
  const variant_quantity = document.getElementById('mm-quantity-main-product');
      mmAddProductToCart(variant_id, { quantity: variant_quantity.value, openCart: true });
    }
  }
} else {
const checkbox = document.querySelector('.mm-container-product-form .mm-check-upsell');
const variant_id = document.getElementById('product_id').value;

const variant_quantity = document.getElementById('mm-quantity-main-product');

console.log('variant', variant_id)
console.log('quantity', variant_quantity)

mmAddProductToCart(variant_id, { quantity: variant_quantity.value, openCart: true });
}
}

function mmProductUpsellIn(inputElem, variantId, parentId) {
  if(inputElem.checked) {
    mmAddProductToCartWithProperty(variantId, parentId);
  } else {
    mmDestroyLineItemFromCart(inputElem.dataset.line);
  }
}

// Check product cart
function mmShowCheckmark(buttonElement) {
     // Affiche le SVG
     const iconContainer = buttonElement.querySelector('svg')?.parentElement;
     if (iconContainer) {
         iconContainer.classList.remove('mm-none');
         iconContainer.classList.add('mm-flex');
     }

     // Masque le texte "Ajouter"
     const addText = buttonElement.querySelector('.mm-product-card-add');
     if (addText) {
         addText.classList.add('mm-none');
     }

     // Affiche le texte "Ajouté"
     const addedText = buttonElement.querySelector('.mm-product-card-added');
     if (addedText) {
         addedText.classList.remove('mm-none');
     }
 }

/*********************************************************************************************
* Loaded Listenner
	*
*/
window.addEventListener('DOMContentLoaded', (event) => {
    mmGetCart();
    //mmOpenCart();
});

document.addEventListener('DOMContentLoaded', () => {
	mmInitSplideRea();
	mmInitSplideCross();
	mmSetupProductForm();
},
{ once: true });


function mmChangeItemVariant(selectElement) {
    const newVariantId = selectElement.value;
    const lineIndex = parseInt(selectElement.getAttribute('data-line-index'), 10);
    const oldVariantId = selectElement.getAttribute('data-variant-id');

    // Récupérer la quantité actuelle pour cette ligne
    const qtySelect = document.querySelector(`select.mm-dc-product-qqty-select[data-line-index="${lineIndex}"]`);
    const quantity = qtySelect ? parseInt(qtySelect.value, 10) : 1;

    // Étape 1 : Supprimer l'ancienne variante
    fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            line: lineIndex,
            quantity: 0
        })
    })
    .then(response => response.json())
    .then(() => {
        // Étape 2 : Ajouter la nouvelle variante
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: newVariantId,
                quantity: quantity,
                sections: mmCartSectionId()
            })
        });
    })
    .then(response => response.json())
    .then(refreshCartFromData)    
    .catch(error => {
        console.error('Erreur lors du changement de variante :', error);
        alert('Une erreur est survenue lors du changement de la variante. Veuillez réessayer.');
    });
}
